<template>
  <div
    v-if="edit"
    class="receipts-container"
  >
    <label
      class="form--label mb-0 "
      :class="required"
    >{{$t('transaction_edit_receipt').toUpperCase()}}</label>
    <div
      v-if="!transactionWithoutReceipt"
      class="d-flex flex-wrap receipts-thumbs"
    >
      <template v-if="!transactionIsLocked && !isProcessing">
        <input-file
          v-if="!isUploading"
          ref="inputFileComponent"
          allowMultiple
          alternateTemplate
          class="mr-2"
          :id="`fileinput-${transactionId}`"
          @change="manageReceipts"
        >
          <span
            class="add-receipt-button mt-2"
            aria-labelledby="add receipt"
          >
            <img
              alt="'icon-add-receipt'"
              :src="require('@/assets/img/icons/icon-add.svg')"
            />
            <span class="add-receipt-button--text">{{$t('ACTION_ADD_RECEIPT').toUpperCase()}}</span>
          </span>
        </input-file>
        <span
          v-if="isUploading"
          class="add-receipt-uploading mt-2"
        >
          <spinner></spinner>
        </span>
      </template>
      <div class="receipt-item-container" v-for="receipt in receipts" :key="receipt.id">
      <media-resource-thumb-viewer
        :receipt="receipt"
        :key="receipt.id"
        class="mr-2 mt-2"
        :onTransactionDetail="false"
        @click="emitShowReceiptModal"
        @handleChangeFileType="handleChangeFileType"
        @handleDownloadFile="handleDownloadFile"
        @handleDeleteFile="handleDeleteFile"
      ></media-resource-thumb-viewer>
      </div>
    </div>
    <div
      v-else
      class="transaction-without-receipts"
      @click="showNotReceiptModal"
    >
      <div class="transaction-without-receipts--container">
        <img
          :src="require('@/assets/img/icon-without-receipt.svg')"
          alt=""
        >
      </div>
      <p class="transaction-without-receipts--notes">{{transactionWithoutReceiptNotes}}</p>
    </div>
    <choose-media-type-modal
      v-if="showMediaTypeModalFlag"
      :open.sync="showMediaTypeModalFlag"
      @typeSelected="typeIsSelected"
    ></choose-media-type-modal>
    <confirm-modal
      v-if="showNotReceiptModalFlag"
      :open.sync="showNotReceiptModalFlag"
      :modalClass="'ModalBox--400'"
      :title="'transaction_without_receipt_modal_title'"
      :message="'transaction_without_receipt_modal_message'"
      :acceptText="'transaction_without_receipt_edit_note'"
      :dismissText="'ACTION_ADD_RECEIPT'"
      acceptBtnClass="blue"
      closeButton
      @accept="editReceiptNote"
      @dismiss="addReceipt"
    ></confirm-modal>
    <input-file
      ref="inputFileWithoutReceipt"
      allowMultiple
      alternateTemplate
      class="mr-2"
      :id="`fileinput-${transactionId}`"
      empty
      @change="manageReceipts"
    >
    </input-file>
    <transaction-not-receipt-modal
      v-if="showEditNoteNotReceiptModalFlag"
      :open.sync="showEditNoteNotReceiptModalFlag"
      edit
      @emitNotReceiptReason="handleNotReceipt"
    ></transaction-not-receipt-modal>
    <confirm-modal
      v-if="showConfirmModal"
      :open.sync="showConfirmModal"
      :modalClass="'ModalBox--400'"
      :title="'media_viewer_delete_resource'"
      :acceptText="'media_viewer_delete_resource'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="Button--danger"
      @accept="deleteReceipt"
      @dismiss="dismissDelete"
    ></confirm-modal>
    <confirm-modal
      v-if="showChangeFileType"
      :open.sync="showChangeFileType"
      acceptBtnClass="Button--primary"
      dismissBtnClass="Button--cancel"
      :modalClass="'ModalBox--400'"
      :dismissText="'ACTION_CANCEL'"
      :acceptText="$t(`transactions_receipt_type_change_${newFileType}`)"
      :title="$t(`transactions_receipt_type_change_${newFileType}`)"
      :message="'transactions_receipt_type_change_question'"
      @accept="changeFileType"
      @dismiss="dismissChangeFileType"
    ></confirm-modal>
  </div>
  <div
    v-else
    class="transaction-detail-container"
  >
    <p class="transaction-detail-header">{{ $t('transaction_edit_receipt') }}</p>
    <p
      v-if="!transactionWithoutReceipt && receipts.length === 0"
      class="transaction-detail-empty-receipt"
    >{{ $t('trasaction_detail_empty_receipt') }}</p>
    <div
      v-if="!transactionWithoutReceipt"
      class="d-flex flex-wrap receipts-thumbs"
    >
    <div class="receipt-item-container" v-for="receipt in receipts" :key="receipt.id">
      <media-resource-thumb-viewer
        :receipt="receipt"
        :key="receipt.id"
        :dropdownHidden="true"
        class="mr-2 mb-2"
        @click="emitShowReceiptModal"
        onTransactionDetail
      ></media-resource-thumb-viewer>
    </div>
    </div>
    <div
      v-else
      class="transaction-without-receipts transaction-without-receipts-detail"
    >
      <div class="transaction-without-receipts--container">
        <img
          :src="require('@/assets/img/icon-without-receipt.svg')"
          alt=""
        >
        <p class="transaction-without-receipts--whithout-receipt">{{$t('trasaction_detail_without_receipt')}}</p>
      </div>
      <p class="transaction-without-receipts--notes">{{transactionWithoutReceiptNotes}}</p>
    </div>
  </div>
</template>
<script>
import { segmentTrack } from '@/analytics/segment'
import { MEDIA_TYPE } from '@/modules/transactions/_constants/MediaType'
import { getResourceFromAws } from '@/shared/_api'
import { EXPENSE_TYPES } from '@/modules/transactions/_constants/constants'

import MediaResourceThumbViewer from '@/components/Commons/MediaResourceThumbViewer'
import InputFile from '@/components/Commons/Forms/InputFile'
import Spinner from '@/components/Commons/Spinner'

const TransactionNotReceiptModal = () => import('@/modules/transactions/_components/_shared/TransactionNotReceiptModal')
const ChooseMediaTypeModal = () => import('@/modules/transactions/_components/media/ChooseMediaTypeModal.vue')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
export default {
  name: 'ReceiptsContainer',
  components: {
    MediaResourceThumbViewer,
    InputFile,
    Spinner,
    ChooseMediaTypeModal,
    TransactionNotReceiptModal,
    ConfirmModal
  },
  data () {
    return {
      showMediaTypeModalFlag: false,
      uploadingReceipts: false,
      showNotReceiptModalFlag: false,
      showEditNoteNotReceiptModalFlag: false,
      showConfirmModal: false,
      showChangeFileType: false,
      receiptLocalId: 1,
      callback: false
    }
  },
  props: {
    edit: {
      type: Boolean,
      default: true
    },
    required: {
      type: String,
      default: ''
    },
    transactionWithoutReceipt: {
      type: Boolean,
      default: false
    },
    transactionIsLocked: {
      type: Boolean,
      default: false
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    transactionId: {
      type: [String, Number],
      default: null
    },
    receipts: {
      type: Array,
      default: () => []
    },
    transactionWithoutReceiptNotes: {
      type: String,
      default: ''
    },
    expenseType: {
      type: String
    }
  },
  computed: {
    MEDIA_TYPE () {
      return MEDIA_TYPE
    },
    transaction () {
      return this.$store.getters['TransactionsStore/currentTransaction']
    },
    receiptUploadByDragAndDrop () {
      return this.$store.getters['TransactionsStore/receiptUploadingByDragAndDrop']
    },
    isUploading () {
      return this.receiptUploadByDragAndDrop || this.uploadingReceipts
    }
  },
  methods: {
    async deleteReceipt () {
      if (this.transactionId) {
        await this.$store.dispatch('TransactionsStore/deleteTransactionReceipt', this.receiptToDelete)
        await this.$store.dispatch('TransactionsStore/fetchTransaction', this.transactionId)

        segmentTrack('Transaction ticket removed', {
          transaction_id: this.transactionId,
          picture_count: this.transactionReceipts ? this.transactionReceipts.length : 0,
          tickets_removed: 1 // tickets are removed one by one
        })
      } else {
        this.$store.dispatch('TransactionsStore/deleteExpenseReceipt', this.receiptToDelete)
      }
      this.receiptToDelete = null
    },
    changeFileType () {
      if (this.transactionId && this.transaction?.receipt?.receiptMedia) {
        this.transaction.receipt.receiptMedia.forEach(item => {
          if (item.media.id === this.resourceId) {
            item.media.isBill = !item.media.isBill
            this.$store.dispatch('TransactionsStore/changeTransactionReceiptType', { resourceId: this.resourceId, isBill: item.media.isBill })
          }
        })
      } else if (this.transactionId) {
        this.expensesReceipts.forEach(item => {
          if (item.media.id === this.resourceId) {
            item.media.isBill = !item.media.isBill
            this.$store.dispatch('TransactionsStore/changeTransactionReceiptType', { resourceId: this.resourceId, isBill: item.media.isBill })
          }
        })
      }
    },
    dismissChangeFileType () {
      this.resourceId = null
      this.newFileType = null
    },
    dismissDelete () {
      this.receiptToDelete = null
    },
    async handleDeleteFile (receiptToDelete) {
      this.receiptToDelete = receiptToDelete
      this.showConfirmModal = true
    },
    showEditNoteNotReceiptModal () {
      this.showEditNoteNotReceiptModalFlag = true
    },
    showNotReceiptModal () {
      this.showNotReceiptModalFlag = !this.showNotReceiptModalFlag
    },
    async handleNotReceipt (reason) {
      try {
        const sendData = {
          id: this.transactionId,
          withoutTicket: true,
          withoutTicketNotes: reason
        }
        this.$store.dispatch('TransactionsStore/editTransaction', { transactionInformation: sendData, originalTransaction: this.transaction })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transaction_dont_send_to_devoluiva_error' }, { root: true })
        // Revert change
        this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      }
    },
    editReceiptNote () {
      this.showNotReceiptModalFlag = false
      this.showEditNoteNotReceiptModalFlag = true
    },
    addReceipt (callback) {
      this.callback = callback
      this.showNotReceiptModalFlag = false
      this.$refs.inputFileWithoutReceipt.$refs.inputFile.click()
    },
    manageReceipts (event) {
      this.receiptUploaded = event
      this.showMediaTypeModal()
    },
    showMediaTypeModal () {
      this.showMediaTypeModalFlag = true
    },
    typeIsSelected (type) {
      this.typeSelected = type
      if (this.transactionId) this.uploadReceipts(this.receiptUploaded)
      else this.setExpenseReceipts(this.receiptUploaded)
    },
    emitShowReceiptModal (event) {
      this.$emit('showReceiptModal', { transactionId: this.transactionId, receiptId: event })
    },
    handleChangeFileType (resourceId, resourceType) {
      this.resourceId = resourceId
      this.newFileType = resourceType === MEDIA_TYPE.BILL ? MEDIA_TYPE.RECEIPT : MEDIA_TYPE.BILL
      this.showChangeFileType = true
    },
    async setExpenseReceipts (event) {
      const receipts = []

      if (event.length && event.length > 0) {
        const receivedFileList = [...event]
        receivedFileList.forEach((el) => {
          const receiptLocalIdAux = this.receiptLocalId++
          receipts.push({
            id: receiptLocalIdAux,
            file: el,
            media: {
              id: receiptLocalIdAux,
              type: this.typeSelected
            }
          })
        })
      }

      this.$store.dispatch('TransactionsStore/addExpensesReceipts', receipts)
      if (this.callback) {
        this.$emit('sendToReview')
      }
      if (this.expenseType === EXPENSE_TYPES.EXPENSE) {
        this.$emit('createDraft')
      }
      if (!localStorage.getItem('uploadInProgress')) {
        this.showUploadInProgress = true
      }
    },
    async handleDownloadFile (resourceId) {
      try {
        const fetchedResource = await getResourceFromAws(resourceId)
        this.fetchedResourceLink = document.createElement('a')
        this.fetchedResourceLink.href = URL.createObjectURL(fetchedResource.data)
        const resourceUrl = new URL(encodeURI(fetchedResource.request.responseURL))
        const resourceParams = resourceUrl.searchParams.get('response-content-disposition')
        const resourceName = resourceParams.substring(resourceParams.indexOf('filename') + 11, resourceParams.length)
        this.fetchedResourceLink.download = resourceName || 'resource-' + resourceId
        this.$emit('resourceDownloaded', resourceId)
      } catch (error) {
      } finally {
        this.fetchedResourceLink.click()
      }
    },
    async uploadReceipts (files, uploadByDragAndDrop = false) {
      if (!uploadByDragAndDrop) {
        if (this.uploadingReceipts) return
        this.uploadingReceipts = true
      }

      await this.$store
        .dispatch('TransactionsStore/submitTransactionReceipt', {
          id: this.transactionId,
          type: this.typeSelected,
          files: files
        }).then(async () => {
          this.$emit('uploadedReceipt', files.length)
          if (this.callback) {
            await this.$store.dispatch(
              'TransactionsStore/fetchTransaction',
              this.transactionId
            )
            this.$emit('sendToReview')
          }
          this.files = null
          this.uploadingReceipts = false
        })
      if (!localStorage.getItem('uploadInProgress')) {
        this.showUploadInProgress = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.transaction-without-receipts {
  display: flex;
  align-items: flex-start;
  background: var(--fill-text-area);
  border-radius: 4px;
  padding: 14px 12px 14px 16px;
  cursor: pointer;
  &--container {
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    flex-direction: column;
    width: 40px;
    height: 40px;
    background: var(--fill-text-area);
  }
  &.transaction-without-receipts-detail {
    cursor: default;
    align-items: center;
    .transaction-without-receipts--container {
      width: 80px;
      height: 135px;
      border: 1px solid var(--fill-divider);
      border-radius: 8px;
    }
  }

  &--notes {
    flex: 1;
    margin-bottom: 0;
    margin-left: 12px;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--text-body);
    word-break: break-word;
  }
  &--whithout-receipt {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-body);
  }
  img {
    width: 40px;
    height: 40px;
  }
  &.transaction-without-receipts-detail {
    padding: 0;
    align-items: flex-start;
  }
}

.transaction-detail-container {
  .transaction-detail-header {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: var(--text-heading);
  }
}
.receipt-item-container {
  position: relative;
}
</style>
